/*******************************************************************************
Remove Hashes From URL
Removes #hashes from the URL address bar.
*******************************************************************************/

export default function removeHashesFromURL() {
    const { hash } = window.location;
    const currentURL = window.location.href;
    const newURL = currentURL.replace(hash, '');

    // Keep the original hash around just in case
    window.urlHashRW = hash;

    window.history.replaceState('', document.title, newURL);
}
